import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    title: {
      md: 'subtitle-4',
      sm: 'body-3'
    },
    toggle: {
      md: 'py-4',
      sm: 'py-3'
    }
  },
  fallbackIcon: 'plus',
  fallbackIconCollapse: 'minus',
  iconSize: {
    md: 'md',
    sm: 'md'
  }
} satisfies RecursivePartial<VfConfig['accordion']>
